module.exports = __webpack_public_path__ + "static/favicon-93120f024cd4ba890e9f89b1219aada9.png";